import { render } from "./Bottom.vue?vue&type=template&id=42e26d98"
import script from "./Bottom.vue?vue&type=script&lang=js"
export * from "./Bottom.vue?vue&type=script&lang=js"
script.render = render

export default script